import { useRef, WheelEvent } from 'react';

interface WheelOptions {
  onWheelStart?: (e: WheelEvent) => void;
  onWheelStop?: (e: WheelEvent) => void;
  onWheelEvent?: (e: WheelEvent) => void;
  delay?: number;
}

const useWheelEvents = ({
  onWheelStart,
  onWheelStop,
  onWheelEvent,
  delay,
}: WheelOptions) => {
  const isScrolling = useRef(false);
  const timeoutId = useRef<NodeJS.Timeout | null>(null);

  return {
    onWheel: (event: WheelEvent) => {
      if (onWheelEvent) onWheelEvent(event);

      if (!isScrolling.current) {
        isScrolling.current = true;
        if (onWheelStart) onWheelStart(event);
      }

      if (timeoutId.current) {
        clearTimeout(timeoutId.current);
      }

      timeoutId.current = setTimeout(() => {
        isScrolling.current = false;
        if (onWheelStop) onWheelStop(event);
      }, delay);
    },
  };
};

export default useWheelEvents;
